import React from "react";
import styles from "./SellingProduct.module.css";
import profile from "../images/image.svg";
import phone from "../images/phones.svg";

const SellingProduct = () => {
  return (
    <section className={styles.hero}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <h1 className={styles.heading}>
              Commence selling products or services directly through{" "}
              <span className={styles.highlight}>conversation</span>
            </h1>
            <p className={styles.text}>
              With our platform, you can easily track sales and manage
              inventory, making it easier to keep track of your transactions and
              products.
            </p>
            <div className={styles.stats}></div>
            <button className={styles.button}>Start Chatting Now</button>
          </div>
          <div className="col-lg-5">
            {/* <div> */}
              <img src={phone} alt="Hero" className={styles.heroImage} />
            {/* </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellingProduct;
